// extracted by mini-css-extract-plugin
export default {"base":"UserDetails_base__AEif+","goback":"UserDetails_goback__aa-7o","title":"UserDetails_title__+9VSV"};